import * as React from "react";

import Box from "@mui/material/Box";
import CircularProgress, {
  circularProgressClasses,
  CircularProgressProps,
} from "@mui/material/CircularProgress";

import "./styles.css";

function FacebookCircularProgress(props: CircularProgressProps) {
  return (
    <Box sx={{ position: "relative" }}>
      <CircularProgress
        variant="determinate"
        sx={(theme) => ({
          color: theme.palette.grey[300],
          ...theme.applyStyles("dark", {
            color: theme.palette.grey[900],
          }),
        })}
        size={35}
        thickness={6}
        {...props}
        value={100}
      />
      <CircularProgress
        variant="indeterminate"
        disableShrink
        sx={(theme) => ({
          color: "#1a90ff",
          animationDuration: "700ms",
          position: "absolute",
          left: 0,
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: "round",
          },
          ...theme.applyStyles("dark", {
            color: "#308fe8",
          }),
        })}
        size={35}
        thickness={6}
        {...props}
      />
    </Box>
  );
}

export default function LoadingSpinner() {
  return (
    <div className="loading-spinner">
      <FacebookCircularProgress className="spinner" />
      <p className="loading-text">Loading properties...</p>
    </div>
  );
}
